import { JobSchedule } from 'types/job_schedule'
import { PaginationParameter } from '../../common/pagination'
import axiosForGigbaseBiz from '../../config'
import { DataResponse } from '../../response'
import { mergeURL } from '../lib'

const resource = ['spotwork_jobs', 'job_schedules']

export const requests = {
  fetchIndex: async (job_id: string, params: PaginationParameter) => {
    return await axiosForGigbaseBiz.get<DataResponse<JobSchedule[]>>(
      mergeURL(resource[0], job_id.toString(), resource[1]),
      {
        params,
      },
    )
  },
}
